export const timeZones = [
//   {
//     value: "Asia/Riyadh",
//     label: "(GMT+03:00) Asia/Riyadh (Saudi Arabia Standard Time)",
//   },
  {
    value: "Asia/Kuwait",
    label: "(GMT+03:00) Asia/Kuwait (Arabia Standard Time)",
  },
//   {
//     value: "Asia/Qatar",
//     label: "(GMT+03:00) Asia/Qatar (Arabia Standard Time)",
//   },
//   {
//     value: "Asia/Dubai",
//     label: "(GMT+04:00) Asia/Dubai (Gulf Standard Time)",
//   },
//   {
//     value: "Asia/Bahrain",
//     label: "(GMT+03:00) Asia/Bahrain (Arabia Standard Time)",
//   },
  {
    value: "Africa/Cairo",
    label: "(GMT+02:00) Africa/Cairo (Eastern European Time)",
  },
  {
    value: "Asia/Damascus",
    label: "(GMT+02:00) Asia/Damascus (Eastern European Time)",
  },
];
